import { ArticleCard } from '@americanexpress/consumer-travel-base';
import clsx from 'clsx';
import { useIntl } from 'react-intl';
import { useReactlytics } from '@americanexpress/reactlytics';
import type { MarketingTilesCardProps } from '../../types/components';
import styles from './MarketingTiles.scss';

export const MarketingTilesCard = ({
  className,
  content: {
    heading,
    subHeading,
    ctaLabel,
    redirectUrl,
    analyticElement: analyticElementProp,
    imageUrl,
    imageLocationLabel,
    reactlyticsDetail: reactlyticsDetailProp,
    hasDisplayEarlyTenureBadge,
  },
  index,
}: MarketingTilesCardProps) => {
  const { formatMessage } = useIntl();
  const { track } = useReactlytics();
  const analyticDetail = reactlyticsDetailProp || `hp-tiles-${index}`;
  const earlyTenureBadgeLabel = hasDisplayEarlyTenureBadge && formatMessage({ id: 'marketingTile.label' });

  return (
    <div
      id={`marketingTile${index}`}
      className={clsx('position-relative margin-2-b', styles.marketingTilesCardWrapper, className)}
      data-testid={`marketing-tiles-card-${index}`}
    >
      <ArticleCard
        className={styles.marketingTilesCard}
          title={heading}
          body={subHeading}
          imageUrl={imageUrl}
          badge={earlyTenureBadgeLabel || imageLocationLabel}
          triggerOnClickAnalytics={track({
            event: {
              type: "click",
              identifier: analyticDetail,
            },
          })}
          cta={{
            label: ctaLabel,
            link: redirectUrl
          }}
          orientation="vertical"
      />
    </div>
  );
};